export { default as CenteredText } from './CenteredText';
